import { Updatable } from '../../..';
import { ISerializable } from '../../../Entity';

export default class MonobankSettings extends Updatable implements ISerializable {
    token: string;
    destination: string;
    walletId: string;

    constructor(settings?: Partial<MonobankSettings>) {
        super();
        if (settings) this.update(settings);
    }

    update(entity: Partial<MonobankSettings>, allowUndefined = false) {
        super.update(entity, allowUndefined);
    }

    toJson() {
        return {
            ...this
        }
    }
}
